// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WvxkR","Footer__container":"Footer_Footer__container__w+L6N"};